import {
  BUSINESS_TYPES,
  BUY_SELL_HUBSPOT_VALUES,
  FIELD_VALUES,
  HUBSPOT_STAGES,
} from "./config";

export function transformBuyOrSellValues(value?: string) {
  if (!value) {
    throw new Error("buyOrSell value is required");
  }
  const transformerValue = value.toUpperCase().trim();
  if (!(transformerValue in BUY_SELL_HUBSPOT_VALUES)) {
    throw new Error("Invalid buyOrSell value");
  }
  const transformedValue = BUY_SELL_HUBSPOT_VALUES[transformerValue];
  return transformedValue;
}

export function transformBusinessType(value?: string) {
  if (!value) {
    throw new Error("businessType value is required");
  }
  const transformerValue = value.toUpperCase().trim();
  if (!(transformerValue in BUSINESS_TYPES)) {
    throw new Error("Invalid businessType value");
  }
  const transformedValue = BUSINESS_TYPES[transformerValue];
  return transformedValue;
}

export function transformDealStage(value?: string) {
  if (!value) {
    throw new Error("stage value is required");
  }
  const transformerValue = value.toUpperCase().trim();
  if (!(transformerValue in HUBSPOT_STAGES)) {
    throw new Error("Invalid stage value");
  }
  const transformedValue = HUBSPOT_STAGES[transformerValue];
  return transformedValue;
}

export function transformFieldValue(value?: string) {
  if (!value) {
    throw new Error("field value is required");
  }
  const transformerValue = value.toUpperCase().trim();
  if (!(transformerValue in FIELD_VALUES)) {
    throw new Error("Invalid field value");
  }
  const transformedValue = FIELD_VALUES[transformerValue];
  return transformedValue;
}

export function transformDealValueToName(value: string): string {
  if (
    value === HUBSPOT_STAGES.BUY_CLOSED_WON ||
    value === HUBSPOT_STAGES.SELL_CLOSED_WON
  ) {
    return "CLOSED_WON";
  }
  if (
    value === HUBSPOT_STAGES.BUY_BUSINESS_LOST ||
    value === HUBSPOT_STAGES.SELL_BUSINESS_LOST
  ) {
    return "CLOSED_LOST";
  }
  const stageName = Object.keys(HUBSPOT_STAGES).find(
    (key) => HUBSPOT_STAGES[key] === value,
  );

  if (!stageName) {
    return `Invalid HubSpot stage ID: ${value}`;
  }

  return stageName;
}
